import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateServiceDataComponent } from './create-service-data.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreateServiceDataComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    CreateServiceDataComponent
  ]
})
export class CreateServiceDataModule { }
